import {
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";

import { useDispatch } from "react-redux";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../styles/NewArrival.css";
import {
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../../components/Wishlist/WishlistSlice";

import { addToCart } from "../../Checkout/Cart/redux/cartSlice";
import { useCartWishlist } from "../../../app/CartWishlistContext";
import {
  formatDiscount,
  formatPrice,
} from "../../../utils/price.utils";

import { limitChars } from "../../../utils/text.utils";
import { getProductPdpUrl } from "../../../utils/url.utils";
import { GetHomeProductBySlug } from "../services/productListng.service";
import { toast } from "react-hot-toast";


export default function WhatNewDontMissOut({
  onQuickView,
}) {
  const swiperRef = useRef(null);
  const [products, setProducts] = useState([]);

  // Professional loaders
  const [cartLoading, setCartLoading] =
    useState({});
  const [wishlistLoading, setWishlistLoading] =
    useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { getCartWishlistCount } =
    useCartWishlist();

  const isLoggedIn =
    !!localStorage.getItem("token");

  // Fetch products
  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     try {
  //       const data =
  //         await GetHomeProductBySlug(
  //           "BATH_ESSENTIALS"
  //         );

  //       setProducts(data || []);
  //     } catch (error) {
  //       console.error(error);
  //       toast.error("Failed to fetch products");
  //     }
  //   };

  //   fetchProducts();
  // }, []);

  useEffect(() => {
  const fetchProducts = async () => {
    try {
      const response =
        await GetHomeProductBySlug(
          "BATH_ESSENTIALS"
        );

      console.log(
        "API RESPONSE:",
        response
      );

      // SAFE ARRAY FIX
      let productData = [];

      if (Array.isArray(response)) {
        productData = response;
      } else if (
        Array.isArray(response?.data)
      ) {
        productData = response.data;
      } else if (
        Array.isArray(response?.products)
      ) {
        productData = response.products;
      }

      setProducts(productData);

    } catch (error) {
      // console.log(error);
      setProducts([]);
    }
  };

  fetchProducts();
}, []);

  // Update product helper
  const updateProduct = useCallback(
    (productId, updates) => {
      setProducts((prev) =>
        prev.map((p) =>
          p.id === productId
            ? {
                ...p,
                ...updates,
              }
            : p
        )
      );
    },
    []
  );

  // Wishlist
  const toggleWishlist = async (
    e,
    product
  ) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: location.pathname,
        },
      });

      return;
    }

    try {
      setWishlistLoading((prev) => ({
        ...prev,
        [product.id]: true,
      }));

      if (product.is_wishlisted) {
        const wishlistId =
          product.wishlist?.[0]
            ?.wishlist_id;

        if (wishlistId) {
          await dispatch(
            removeFromWishlist(wishlistId)
          ).unwrap();

          updateProduct(product.id, {
            is_wishlisted: false,
            wishlist: [],
          });
        }
      } else {
        const response = await dispatch(
          addToWishlist({
            product_id: product.id,
          })
        ).unwrap();

        const wishlist = Array.isArray(
          response
        )
          ? response.find(
              (w) =>
                w.product_id === product.id
            )
          : response;

        updateProduct(product.id, {
          is_wishlisted: true,
          wishlist: wishlist
            ? [{ wishlist_id: wishlist.id }]
            : [],
        });
      }

      getCartWishlistCount();
    } catch (error) {
      console.error(error);

      toast.error("Something went wrong");
    } finally {
      setWishlistLoading((prev) => ({
        ...prev,
        [product.id]: false,
      }));
    }
  };

  // Add to cart
  const handleAddToCart = async (
    e,
    product
  ) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: location.pathname,
        },
      });

      return;
    }

    try {
      setCartLoading((prev) => ({
        ...prev,
        [product.id]: true,
      }));

      const quantity = 1;

      const res = await dispatch(
        addToCart({
          product_id: product.id,
          quantity,
        })
      ).unwrap();

      toast.success(
        res?.data?.message ||
          "Added to cart"
      );

      updateProduct(product.id, {
        addedToCartQuantity:
          (product.addedToCartQuantity || 0) +
          quantity,
      });

      getCartWishlistCount();
    } catch (error) {
      console.error(error);

      toast.error(
        error?.message ||
          "Failed to add to cart"
      );
    } finally {
      setCartLoading((prev) => ({
        ...prev,
        [product.id]: false,
      }));
    }
  };

//  if (!products || products.length === 0) {
//     return null;
//   }

 // FIXED CONDITION
  if (
    !Array.isArray(products) ||
    products.length === 0
  ) {
    return null;
  }

  return (
    <section className="Newarrivals-section">
      <h2>New On The Block</h2>

      <div className="container container-padding">
        <div className="product-swiper-wrapper">
          <button
            className="custom-prev"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <button
            className="custom-next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <i className="bi bi-chevron-right"></i>
          </button>

          <Swiper
            modules={[Navigation]}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            spaceBetween={20}
            slidesPerView={5}
            loop
            speed={200}
            breakpoints={{
              320: { slidesPerView: 2.2 },
              480: { slidesPerView: 2.2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 5 },
            }}
          >
             {Array.isArray(products) &&
                  products.map((item) => {
              const hoverImage =
                item.media_list?.main?.file || "";

              const mainImage =
                item.media_list?.hover?.file || hoverImage;

              const isCartLoading =
                cartLoading[item.id];

              const isWishlistLoading =
                wishlistLoading[item.id];

              return (
                  <SwiperSlide key={item.id}>
                  <div className="product-card">
                    <div
                      className="image-box fixed-product-image"
                      onClick={() =>
                        window.open(
                          getProductPdpUrl(
                            item.action_url,
                            item.sku
                          ),
                          "_blank"
                        )
                      }
                    >
                      <img
                        src={mainImage}
                        alt={item.name}
                        className="main-img"
                        loading="lazy"
                      />

                      <img
                        src={hoverImage}
                        alt={item.name}
                        className="hover-img"
                        loading="lazy"
                      />

                      <div className="icons-pr">
                        {/* Wishlist */}
                          <div className="tooltip-wrap">
                        <button
                          onClick={(e) =>
                            toggleWishlist(
                              e,
                              item
                            )
                          }
                          className="icon-action-btn"
                          disabled={
                            isWishlistLoading
                          }
                        >
                          {isWishlistLoading ? (
                            <span className="icon-skeleton-loader">
                              <span className="icon-shimmer"></span>
                            </span>
                          ) : (
                            <i
                              className={
                                item.is_wishlisted
                                  ? "bi bi-heart-fill active"
                                  : "bi bi-heart"
                              }
                            />
                          )}
                        </button>
                         <span className="left-tooltip">
                            Add to wishlist
                          </span>
                        </div>
                      </div>
                    </div>

                   <div className="details">
                      <h4 className="title-limit">
                        <Link
                          to={getProductPdpUrl(
                            item.action_url,
                            item.sku
                          )}
                          target="_blank"
                        >
                          {limitChars(item.name, 29)}
                        </Link>
                      </h4>

                      <div className="price">
                        <span className="new">
                          {formatPrice(item.selling_price)}
                        </span>

                        {item.discount_percent > 0 && (
                          <>
                            <span className="old">
                              {formatPrice(item.mrp)}
                            </span>

                            <span className="off">
                              {formatDiscount(
                                item.discount_percent
                              )}
                            </span>
                          </>
                        )}
                      </div>

                      <button
                        className={`btn addtocat-button ${isCartLoading ? "loading" : ""
                          }`}
                        onClick={(e) =>
                          handleAddToCart(e, item)
                        }
                        disabled={isCartLoading}
                      >
                        {isCartLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Adding...
                          </>
                        ) : (
                          "Add to Cart"
                        )}
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}  
          </Swiper>
        </div>
      </div>
    </section>
  );
}